export default {
  namespaced: true,
  directory: {
    title: "Directory",
    name: "Name",
    position: "Position",
    phone1: "Phone 1",
    phone2: "Phone 2"
  },
};
